import { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase/config';
import { useNavigate, Link } from 'react-router-dom';

export default function Dashboard() {
  const [stats, setStats] = useState({
    totalMatches: 0,
    totalUsers: 0,
    pendingDeposits: 0,
    pendingWithdrawals: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStats = async () => {
      const matchSnap = await getDocs(collection(db, 'matches'));
      const userSnap = await getDocs(collection(db, 'users'));
      const depSnap = await getDocs(query(collection(db, 'deposits'), where('status', '==', 'pending')));
      const withSnap = await getDocs(query(collection(db, 'withdrawals'), where('status', '==', 'pending')));
      setStats({
        totalMatches: matchSnap.size,
        totalUsers: userSnap.size,
        pendingDeposits: depSnap.size,
        pendingWithdrawals: withSnap.size,
      });
    };
    fetchStats();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <div style={styles.container}>

      {/* Sidebar */}
      <div style={styles.sidebar}>
        <div style={styles.sidebarLogo}>🎮 FF Arena</div>
        <div style={styles.sidebarSub}>Admin Panel</div>
        <nav style={styles.nav}>
  <Link to="/" style={styles.navItemActive}>🏠 Dashboard</Link>
<Link to="/matches" style={styles.navItem}>🎯 Matches</Link>
<Link to="/results" style={styles.navItem}>🏆 Results</Link>
<Link to="/users" style={styles.navItem}>👥 Users</Link>
<Link to="/deposits" style={styles.navItem}>💰 Deposits</Link>
<Link to="/withdrawals" style={styles.navItem}>⬆️ Withdrawals</Link>
<Link to="/settings" style={styles.navItem}>⚙️ Settings</Link>
<Link to="/password-resets" style={styles.navItem}>🔑 Password Resets</Link>
<Link to="/videos" style={styles.navItem}>🎬 Videos</Link>

</nav>
        <button style={styles.logoutBtn} onClick={handleLogout}>🚪 Logout</button>
      </div>

      {/* Main */}
      <div style={styles.main}>
        <h1 style={styles.pageTitle}>Dashboard</h1>
        <p style={styles.pageSub}>FF Arena এর সব কিছুর overview</p>

        {/* Stats Grid */}
        <div style={styles.statsGrid}>
          <div style={styles.statCard}>
            <div style={styles.statIcon}>🎯</div>
            <div style={styles.statValue}>{stats.totalMatches}</div>
            <div style={styles.statLabel}>Total Matches</div>
          </div>
          <div style={styles.statCard}>
            <div style={styles.statIcon}>👥</div>
            <div style={styles.statValue}>{stats.totalUsers}</div>
            <div style={styles.statLabel}>Total Users</div>
          </div>
          <div style={{ ...styles.statCard, borderColor: '#f4c43066' }}>
            <div style={styles.statIcon}>💰</div>
            <div style={{ ...styles.statValue, color: '#f4c430' }}>{stats.pendingDeposits}</div>
            <div style={styles.statLabel}>Pending Deposits</div>
          </div>
          <div style={{ ...styles.statCard, borderColor: '#ff6b6b66' }}>
            <div style={styles.statIcon}>⬆️</div>
            <div style={{ ...styles.statValue, color: '#ff6b6b' }}>{stats.pendingWithdrawals}</div>
            <div style={styles.statLabel}>Pending Withdrawals</div>
          </div>
        </div>

        {/* Quick Links */}
        <h2 style={styles.sectionTitle}>Quick Actions</h2>
        <div style={styles.quickGrid}>
          <Link to="/matches" style={styles.quickCard}>
            <div style={styles.quickIcon}>➕</div>
            <div style={styles.quickLabel}>নতুন Match Add করো</div>
          </Link>
          <Link to="/deposits" style={styles.quickCard}>
            <div style={styles.quickIcon}>✅</div>
            <div style={styles.quickLabel}>Deposits Approve করো</div>
          </Link>
          <Link to="/withdrawals" style={styles.quickCard}>
            <div style={styles.quickIcon}>💸</div>
            <div style={styles.quickLabel}>Withdrawals Process করো</div>
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex', minHeight: '100vh', background: '#0a0a1a',
  },
  sidebar: {
    width: 240, background: '#111128', borderRight: '1px solid #1e1e3a',
    padding: '24px 0', display: 'flex', flexDirection: 'column',
    position: 'fixed', height: '100vh',
  },
  sidebarLogo: {
    color: '#f4c430', fontSize: 20, fontWeight: 'bold',
    padding: '0 24px', marginBottom: 4,
  },
  sidebarSub: {
    color: '#555', fontSize: 12, padding: '0 24px', marginBottom: 32,
  },
  nav: { display: 'flex', flexDirection: 'column', flex: 1 },
  navItem: {
    color: '#888', textDecoration: 'none', padding: '12px 24px',
    fontSize: 14, fontWeight: '500', borderLeft: '3px solid transparent',
  },
  navItemActive: {
    color: '#f4c430', textDecoration: 'none', padding: '12px 24px',
    fontSize: 14, fontWeight: '600', borderLeft: '3px solid #f4c430',
    background: '#f4c43011',
  },
  logoutBtn: {
    background: '#ff444422', border: '1px solid #ff444444',
    color: '#ff6b6b', borderRadius: 10, padding: '10px 16px',
    cursor: 'pointer', margin: '0 16px', fontSize: 14, fontWeight: '600',
  },
  main: { marginLeft: 240, flex: 1, padding: 32 },
  pageTitle: { color: '#fff', fontSize: 28, fontWeight: 'bold', margin: 0 },
  pageSub: { color: '#666', fontSize: 14, marginTop: 6, marginBottom: 32 },
  statsGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 40,
  },
  statCard: {
    background: '#111128', borderRadius: 16, padding: 24,
    border: '1px solid #1e1e3a', textAlign: 'center',
  },
  statIcon: { fontSize: 32, marginBottom: 12 },
  statValue: { color: '#fff', fontSize: 32, fontWeight: 'bold', marginBottom: 6 },
  statLabel: { color: '#666', fontSize: 13 },
  sectionTitle: { color: '#fff', fontSize: 18, fontWeight: 'bold', marginBottom: 16 },
  quickGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 },
  quickCard: {
    background: '#111128', borderRadius: 16, padding: 24,
    border: '1px solid #1e1e3a', textAlign: 'center',
    textDecoration: 'none', cursor: 'pointer',
  },
  quickIcon: { fontSize: 32, marginBottom: 12 },
  quickLabel: { color: '#ccc', fontSize: 14, fontWeight: '500' },
};